import axios, { AxiosError } from "axios";
import { useQuery, useMutation } from "react-query";
import { API_URL } from "../consts";
import { CardsData } from "../prenotazione/CardsData";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { RigaSocio } from "../prenotazione/RigaSocio";
import { Loading } from "../ui/Loading";
import { Transazioni_Causali } from "../prismaTypes";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { uiStore } from "../uiStore";
import { queryClient } from "../App";
import Alert from "@mui/material/Alert";

type Inputs = {
  idConto: number;
  importo: number;
  idCausale: number;
  note: string;
};
const schema = yup
  .object({
    idConto: yup.number().typeError("Seleziona un conto!").required(),
    importo: yup.number().typeError("Importo deve essere un numero!").min(0).required(),
    idCausale: yup.number().typeError("Seleziona una causale!").required(),
    note: yup.string(),
  })
  .required();

export function AddTran() {
  const { enqueueSnackbar } = useSnackbar();
  const setTitle = uiStore((state) => state.setTitle);

  useEffect(() => {
    setTitle("Gestione Transazioni");
  }, [setTitle]);

  const { isLoading, data: membri } = useQuery<{ cards: CardsData[] }, AxiosError>(
    ["cards/findAllPrenota"],
    () => axios.get(API_URL + "cards/findAllPrenota").then((res) => res.data)
  );
  const { isLoading: isLoading2, data: causali } = useQuery<
    { causali: Transazioni_Causali[] },
    AxiosError
  >(["causali"], () => axios.get(API_URL + "causali").then((res) => res.data));

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const { mutate } = useMutation(
    (data: Inputs) => {
      return axios.post(API_URL + "cards/addMovimento", data);
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Transazione creata", { variant: "success" });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const onSubmit = (data: Inputs) => {
    mutate(data);
  };

  if (isLoading || !membri || isLoading2) return <Loading />;

  if (causali && causali?.causali?.length < 1)
    return <Alert severity="error">È necessario inserire delle causali!</Alert>;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="idConto"
        control={control}
        render={({ field }) => (
          <Autocomplete
            getOptionLabel={(option) => option.codice + " " + option.nome + " " + option.cognome}
            options={membri?.cards}
            onChange={(event: any, newValue: CardsData | null) => {
              setValue(`idConto`, newValue?.idConto ?? -1);
            }}
            value={membri.cards.find((c) => c.idConto === field.value) || null}
            renderOption={(props, option) => (
              <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
                <RigaSocio option={option} />
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                {...field}
                required
                label="Conto"
                variant="standard"
                error={Boolean(errors.idConto)}
                helperText={errors.idConto?.message ?? " "}
              />
            )}
          />
        )}
      />
      <Controller
        name="importo"
        control={control}
        // defaultValue={0}
        render={({ field }) => (
          <TextField
            {...field}
            variant="standard"
            required
            // sx={{ width: 150 }}
            label="Importo"
            type="number"
            error={Boolean(errors.importo)}
            helperText={errors.importo?.message ?? " "}
          />
        )}
      />
      <Controller
        name="idCausale"
        control={control}
        defaultValue={causali?.causali[0].id}
        render={({ field }) => (
          <FormControl {...field} fullWidth variant="standard">
            <InputLabel>Tipologia</InputLabel>
            <Select
              label="Tipologia"
              required
              value={field.value === null ? "" : field.value}
              onChange={(e) => setValue("idCausale", parseInt("" + e.target.value))}
            >
              {causali?.causali?.map((ca) => (
                <MenuItem key={ca.id} value={ca.id}>
                  {ca.descrizione}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
      <Controller
        name="note"
        control={control}
        defaultValue=""
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            multiline
            rows={3}
            variant="standard"
            label="Note"
            error={Boolean(errors.note)}
            helperText={errors.note?.message ?? " "}
          />
        )}
      />

      <Button type="submit" variant="contained" sx={{ mt: 2 }}>
        Inserisci Transazione
      </Button>
    </form>
  );
}
